import React, { useState, useEffect } from "react";



import { Link } from "react-router-dom";
import { collection, getDocs, query, orderBy, where } from "firebase/firestore";
import db from "./Firebase";
import Swal from "sweetalert2";
import moment from "moment";

const GrowDraft = () => {
    const [uniqueBackgrounds, setUniqueBackgrounds] = useState({});
    const [sortOrder, setSortOrder] = useState("asc");
    const [personalDetails, setPersonalDetails] = useState({}); // Store personal details
    const [categories, setCategories] = useState({}); // Store category mapping

    useEffect(() => {
        fetchCategories(); // Fetch categories from nv_cards

    }, []);


    // Function to fetch all data from "nv_cards" and store in a state
    const fetchCategories = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, "nv_cards"));
            let categoryMap = {};
            querySnapshot.forEach((doc) => {
                const { image_url, category } = doc.data();
                if (image_url) {
                    categoryMap[image_url] = category;
                }
            });
            setCategories(categoryMap);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const q = query(
                    collection(db, "nv_users_saved_draft"),
                    orderBy("createdAt", "desc")
                );

                const querySnapshot = await getDocs(q);

                let backgroundMap = {};
                let phoneNumbersToFetch = new Set(); // Collect phone numbers with missing names

                querySnapshot.forEach((doc) => {
                    let { backgroundImage, name, phone_no, createdAt, type } = doc.data(); // ✅ Fetch `type`

                    if (backgroundImage) {
                        if (!backgroundMap[backgroundImage]) {
                            backgroundMap[backgroundImage] = [];
                        }

                        if (!name || name === "null" || name.trim() === "") {
                            phoneNumbersToFetch.add(phone_no);
                        }

                        let formattedDate = "N/A";
                        if (createdAt) {
                            const date = new Date(createdAt);
                            formattedDate = moment(date).format("Do MMMM YYYY");
                        }

                        backgroundMap[backgroundImage].push({
                            name, phone_no, createdAt: formattedDate, type: type || "Unknown" // ✅ Ensure `type` is set
                        });
                    }
                });

                setUniqueBackgrounds(backgroundMap);

                if (phoneNumbersToFetch.size > 0) {
                    fetchPersonalDetails([...phoneNumbersToFetch]);
                }

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    const fetchPersonalDetails = async (phoneNumbers) => {
        let detailsMap = {};
        const batchSize = 10;

        for (let i = 0; i < phoneNumbers.length; i += batchSize) {
            const batch = phoneNumbers.slice(i, i + batchSize);
            const q = query(collection(db, "personal_details"), where("phone_no", "in", batch));

            const snapshot = await getDocs(q);
            snapshot.docs.forEach((doc) => {
                const data = doc.data();
                detailsMap[data.phone_no] = data.full_name || "N/A";
            });
        }

        setPersonalDetails(detailsMap);
    };

    const sortData = () => {
        const sortedData = Object.entries(uniqueBackgrounds)
            .sort(([bg1, users1], [bg2, users2]) => {
                return sortOrder === "asc"
                    ? users1.length - users2.length
                    : users2.length - users1.length;
            });

        setUniqueBackgrounds(Object.fromEntries(sortedData));
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    };

    const handleBackgroundClick = (background) => {
        const users = uniqueBackgrounds[background];

        if (!users || users.length === 0) {
            Swal.fire("No Users", "No users found for this background.", "info");
            return;
        }

        let userListHtml = users
            .map(user => {
                let displayName = user.name;

                if (!displayName || displayName === "null" || displayName.trim() === "") {
                    displayName = personalDetails[user.phone_no] || "Unknown";
                }

                return `<p><strong>${displayName}</strong> - ${user.phone_no}</p>`;
            })
            .join("");

        Swal.fire({
            title: "Users using this Background",
            html: userListHtml,
            icon: "info",
            confirmButtonText: "Close",
            width: "400px"
        });
    };


    return (
        <>
            <div className="p-2 d-flex justify-content-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="p-3">
                <div className="card-header pb-0 px-3 d-flex justify-content-between">
                    <h6 className="mb-2">Grow Background Usage</h6>
                    <Link to="/grow_all_data">
                        <button className="btn btn-success btn-sm">Grow All Data</button>
                    </Link>
                </div>

                {/* Background Table */}
                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>Sr. No</th>
                                <th>Background Image</th>
                                <th style={{ cursor: "pointer" }} onClick={sortData}>
                                    Users Count {sortOrder === "asc" ? "▲" : "▼"}
                                </th>
                                <th>Type</th>
                                <th>Category</th>
                            </tr>
                        </thead>

                        <tbody>
                            {Object.keys(uniqueBackgrounds).map((bg, index) => {
                                const firstUser = uniqueBackgrounds[bg][0];
                                return (
                                    <tr key={index} onClick={() => handleBackgroundClick(bg)} style={{ cursor: "pointer" }}>
                                        <td>{index + 1}</td>
                                        <td><img src={bg} className="me-3" style={{ height: "4rem" }} alt="Background" /></td>
                                        <td>{uniqueBackgrounds[bg].length}</td>
                                        <td>{firstUser.type}</td> {/* ✅ Display type */}
                                        <td>{categories[bg] ? "DIY" : "" || "Ready Made"}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default GrowDraft;


// import React, { useState, useEffect } from "react";


// import { Link } from "react-router-dom";
// import { collection, getDocs, query, orderBy, where } from "firebase/firestore";
// import db from "./Firebase";
// import Swal from "sweetalert2";
// import moment from "moment";

// const GrowDraft = () => {
//     const [uniqueBackgrounds, setUniqueBackgrounds] = useState({});
//     const [sortOrder, setSortOrder] = useState("asc");
//     const [personalDetails, setPersonalDetails] = useState({}); // Store personal details

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const q = query(
//                     collection(db, "nv_users_saved_draft"),
//                     orderBy("createdAt", "desc")
//                 );

//                 const querySnapshot = await getDocs(q);

//                 let backgroundMap = {};
//                 let phoneNumbersToFetch = new Set(); // Collect phone numbers with missing names

//                 querySnapshot.forEach((doc) => {
//                     let { backgroundImage, name, phone_no, createdAt } = doc.data();

//                     if (backgroundImage) {
//                         if (!backgroundMap[backgroundImage]) {
//                             backgroundMap[backgroundImage] = [];
//                         }

//                         // ✅ Check if name is "null" (string) or empty and collect phone number
//                         if (!name || name === "null" || name.trim() === "") {
//                             phoneNumbersToFetch.add(phone_no);
//                         }

//                         let formattedDate = "N/A";
//                         if (createdAt) {
//                             const date = new Date(createdAt);
//                             formattedDate = moment(date).format("Do MMMM YYYY");
//                         }

//                         backgroundMap[backgroundImage].push({ name, phone_no, createdAt: formattedDate });
//                     }
//                 });

//                 setUniqueBackgrounds(backgroundMap);

//                 // ✅ Fetch personal details if needed
//                 if (phoneNumbersToFetch.size > 0) {
//                     fetchPersonalDetails([...phoneNumbersToFetch]);
//                 }

//             } catch (error) {
//                 console.error("Error fetching data:", error);
//             }
//         };

//         fetchData();
//     }, []);


//     // **Fetch personal details for missing names**
//     const fetchPersonalDetails = async (phoneNumbers) => {
//         let detailsMap = {};
//         const batchSize = 10; // Firestore 'in' query limit

//         for (let i = 0; i < phoneNumbers.length; i += batchSize) {
//             const batch = phoneNumbers.slice(i, i + batchSize);
//             const q = query(collection(db, "personal_details"), where("phone_no", "in", batch));

//             const snapshot = await getDocs(q);
//             snapshot.docs.forEach((doc) => {
//                 const data = doc.data();
//                 detailsMap[data.phone_no] = data.full_name || "N/A"; // Default if missing
//             });
//         }

//         setPersonalDetails(detailsMap);
//     };

//     // ✅ Sorting function
//     const sortData = () => {
//         const sortedData = Object.entries(uniqueBackgrounds)
//             .sort(([bg1, users1], [bg2, users2]) => {
//                 return sortOrder === "asc"
//                     ? users1.length - users2.length
//                     : users2.length - users1.length;
//             });

//         setUniqueBackgrounds(Object.fromEntries(sortedData));
//         setSortOrder(sortOrder === "asc" ? "desc" : "asc");
//     };

//     const handleBackgroundClick = (background) => {
//         const users = uniqueBackgrounds[background];

//         if (!users || users.length === 0) {
//             Swal.fire("No Users", "No users found for this background.", "info");
//             return;
//         }

//         let userListHtml = users
//             .map(user => {
//                 let displayName = user.name;

//                 // ✅ If name is "null" or empty, get from `personalDetails`
//                 if (!displayName || displayName === "null" || displayName.trim() === "") {
//                     displayName = personalDetails[user.phone_no] || "Unknown";
//                 }

//                 return `<p><strong>${displayName}</strong> - ${user.phone_no}</p>`;
//             })
//             .join("");

//         Swal.fire({
//             title: "Users using this Background",
//             html: userListHtml,
//             icon: "info",
//             confirmButtonText: "Close",
//             width: "400px"
//         });
//     };


//     return (
//         <>
//             <div className="p-2 d-flex justify-content-between">
//                 <Link to="/">
//                     <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
//                 </Link>
//             </div>

//             <div className="p-3">
//                 <div className="card-header pb-0 px-3 d-flex justify-content-between">
//                     <h6 className="mb-2">Grow Background Usage</h6>
//                     <Link to="/grow_all_data">
//                         <button className="btn btn-success btn-sm">Grow All Data</button>
//                     </Link>
//                 </div>

//                 {/* Background Table */}
//                 <div className="table-responsive fix-width scroll-inner">
//                     <table className="table table-bordered table-hover">
//                         <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
//                             <tr>
//                                 <th>Sr. No</th>
//                                 <th>Background Image</th>
//                                 <th style={{ cursor: "pointer" }} onClick={sortData}>
//                                     Users Count {sortOrder === "asc" ? "▲" : "▼"}
//                                 </th>
//                                 <th>Type</th>
//                                 <th>Created Date</th>
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {Object.keys(uniqueBackgrounds).map((bg, index) => {
//                                 const firstUser = uniqueBackgrounds[bg][0];
//                                 return (
//                                     <tr key={index} onClick={() => handleBackgroundClick(bg)} style={{ cursor: "pointer" }}>
//                                         <td>{index + 1}</td>
//                                         <td><img src={bg} className="me-3" style={{ height: "4rem" }} alt="Background" /></td>
//                                         <td>{uniqueBackgrounds[bg].length}</td>
//                                         <td>{firstUser.type}</td>
//                                         <td>{firstUser.createdAt}</td>
//                                     </tr>
//                                 );
//                             })}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default GrowDraft;


// // import React, { useState, useEffect } from "react";


// // import { Link } from "react-router-dom";
// // import { collection, getDocs, query, orderBy } from "firebase/firestore";
// // import db from "./Firebase";
// // import Swal from "sweetalert2";
// // import moment from "moment";

// // const GrowDraft = () => {
// //     const [uniqueBackgrounds, setUniqueBackgrounds] = useState({});
// //     const [sortOrder, setSortOrder] = useState("asc"); // ✅ Sorting order state


// //     useEffect(() => {
// //         const fetchData = async () => {
// //             try {
// //                 const q = query(
// //                     collection(db, "nv_users_saved_draft"),
// //                     orderBy("createdAt", "desc") // ✅ Ensure Firestore Index exists
// //                 );

// //                 const querySnapshot = await getDocs(q);

// //                 let backgroundMap = {};
// //                 querySnapshot.forEach((doc) => {
// //                     let { backgroundImage, name, phone_no, createdAt } = doc.data();

// //                     if (backgroundImage) {
// //                         if (!backgroundMap[backgroundImage]) {
// //                             backgroundMap[backgroundImage] = [];
// //                         }

// //                         // ✅ Convert Firestore Timestamp to formatted date
// //                         let formattedDate = "N/A";
// //                         if (createdAt) {
// //                             const date = new Date(createdAt); // Convert Firestore Timestamp or string
// //                             formattedDate = moment(date).format("Do MMMM YYYY");
// //                         }

// //                         backgroundMap[backgroundImage].push({ name, phone_no, createdAt: formattedDate });
// //                     }
// //                 });

// //                 setUniqueBackgrounds(backgroundMap);
// //             } catch (error) {
// //                 console.error("Error fetching data:", error);
// //             }
// //         };

// //         fetchData();
// //     }, []);

// //     // ✅ Sorting function
// //     const sortData = () => {
// //         const sortedData = Object.entries(uniqueBackgrounds)
// //             .sort(([bg1, users1], [bg2, users2]) => {
// //                 return sortOrder === "asc"
// //                     ? users1.length - users2.length
// //                     : users2.length - users1.length;
// //             });

// //         setUniqueBackgrounds(Object.fromEntries(sortedData));
// //         setSortOrder(sortOrder === "asc" ? "desc" : "asc"); // ✅ Toggle sort order
// //     };

// //     const handleBackgroundClick = (background) => {
// //         const users = uniqueBackgrounds[background];

// //         if (!users || users.length === 0) {
// //             Swal.fire("No Users", "No users found for this background.", "info");
// //             return;
// //         }

// //         let userListHtml = users
// //             .map(user => `<p><strong>${user.name}</strong> - ${user.phone_no}</p>`)
// //             .join("");

// //         Swal.fire({
// //             title: "Users using this Background",
// //             html: userListHtml,
// //             icon: "info",
// //             confirmButtonText: "Close",
// //             width: "400px"
// //         });
// //     };

// //     return (
// //         <>
// //             <div className="p-2 d-flex justify-content-between">
// //                 <Link to="/">
// //                     <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
// //                 </Link>
// //             </div>

// //             <div className="p-3">

// //                 <div className="card-header pb-0 px-3 d-flex justify-content-between">
// //                                     <h6 className="mb-2">Grow Background Usage</h6>
// //                                     <Link to="/grow_all_data">
// //                                         <button className="btn btn-success btn-sm" >
// //                                             Grow All Data
// //                                         </button>
// //                                     </Link>
// //                                 </div>

// //                 {/* Background Table */}
// //                 <div className="table-responsive fix-width scroll-inner">
// //                     <table className="table table-bordered table-hover">
// //                         <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
// //                             <tr>
// //                                 <th>Sr. No</th>
// //                                 <th>Background Image</th>
// //                                 <th style={{ cursor: "pointer" }} onClick={sortData}>
// //                                     Users Count {sortOrder === "asc" ? "▲" : "▼"} {/* ✅ Add arrow */}
// //                                 </th>
// //                                 <th>Created At</th>
// //                             </tr>
// //                         </thead>

// //                         <tbody>
// //                             {Object.keys(uniqueBackgrounds).map((bg, index) => {
// //                                 const firstUser = uniqueBackgrounds[bg][0];
// //                                 return (
// //                                     <tr key={index} onClick={() => handleBackgroundClick(bg)} style={{ cursor: "pointer" }}>
// //                                         <td>{index + 1}</td>
// //                                         <td><img src={bg} className="me-3" style={{ height: "4rem" }} alt="Background" /></td>
// //                                         <td>{uniqueBackgrounds[bg].length}</td>
// //                                         <td>{firstUser.createdAt}</td>
// //                                     </tr>
// //                                 );
// //                             })}
// //                         </tbody>
// //                     </table>
// //                 </div>
// //             </div>
// //         </>
// //     );
// // };

// // export default GrowDraft;


// // // import React, { useState, useEffect } from "react";


// // // import { Link } from "react-router-dom";
// // // import { collection, getDocs, query } from "firebase/firestore";
// // // import db from "./Firebase";
// // // import Swal from "sweetalert2";
// // // import { extendMoment } from "moment-range";
// // // import Moment from "moment";

// // // const GrowDraft = () => {
// // //     const [uniqueBackgrounds, setUniqueBackgrounds] = useState({});
// // //     const [selectedBackground, setSelectedBackground] = useState(null);
// // //     const [usersWithBackground, setUsersWithBackground] = useState([]);
// // //     const [modalOpen, setModalOpen] = useState(false);
// // //     const moment = extendMoment(Moment);

// // //     useEffect(() => {
// // //         const fetchData = async () => {
// // //             const q = query(collection(db, "nv_users_saved_draft"));
// // //             const querySnapshot = await getDocs(q);

// // //             let backgroundMap = {};
// // //             querySnapshot.forEach((doc) => {
// // //                 const { backgroundImage, name, phone_no, createdAt } = doc.data();
// // //                 if (backgroundImage) {
// // //                     if (!backgroundMap[backgroundImage]) {
// // //                         backgroundMap[backgroundImage] = [];
// // //                     }

// // //                     // Format createdAt date if available
// // //                     const formattedDate = createdAt
// // //                         ? moment(createdAt).format("Do MMMM YYYY")
// // //                         : "N/A";

// // //                     backgroundMap[backgroundImage].push({ name, phone_no, createdAt: formattedDate });
// // //                 }
// // //             });

// // //             setUniqueBackgrounds(backgroundMap);
// // //         };

// // //         fetchData();
// // //     }, []);


// // //     const handleBackgroundClick = (background) => {
// // //         const users = uniqueBackgrounds[background];

// // //         if (!users || users.length === 0) {
// // //             Swal.fire("No Users", "No users found for this background.", "info");
// // //             return;
// // //         }

// // //         let userListHtml = users
// // //             .map(user => `<p><strong>${user.name}</strong> - ${user.phone_no}</p>`)
// // //             .join("");

// // //         Swal.fire({
// // //             title: "Users using this Background",
// // //             html: userListHtml,
// // //             icon: "info",
// // //             confirmButtonText: "Close",
// // //             width: "400px"
// // //         });
// // //     };

// // //     return (
// // //         <>
// // //             <div className="p-2 d-flex justify-content-between">
// // //                 <Link to="/">
// // //                     <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
// // //                 </Link>
// // //             </div>

// // //             <div className="p-3">
// // //                 <h6 className="mb-2">Grow Background Usage</h6>

// // //                 {/* Background Table */}
// // //                 <div className="table-responsive fix-width scroll-inner">
// // //                     <table className="table table-bordered table-hover">
// // //                         <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
// // //                             <tr>
// // //                                 <th>Sr. No</th>
// // //                                 <th>Background Image</th>
// // //                                 <th>Users Count</th>
// // //                             </tr>
// // //                         </thead>

// // //                         <tbody>
// // //                             {Object.keys(uniqueBackgrounds).map((bg, index) => {
// // //                                 // Get the first user with this background to extract the `createdAt` date
// // //                                 const firstUser = uniqueBackgrounds[bg][0];
// // //                                 const formattedDate = firstUser?.createdAt
// // //                                     ? moment(firstUser.createdAt).format("Do MMMM YYYY")
// // //                                     : "N/A"; // Fallback if `createdAt` is missing

// // //                                 return (
// // //                                     <tr key={index} onClick={() => handleBackgroundClick(bg)} style={{ cursor: "pointer" }}>
// // //                                         <td>{index + 1}</td>
// // //                                         <td><img src={bg} className="me-3" style={{ height: "4rem" }} alt="Background" /></td>
// // //                                         <td>{uniqueBackgrounds[bg].length}</td>
// // //                                         <td>{formattedDate}</td>
// // //                                     </tr>
// // //                                 );
// // //                             })}
// // //                         </tbody>
// // //                     </table>
// // //                 </div>
// // //             </div>

// // //             {/* Modal */}
// // //             {modalOpen && (
// // //                 <div className="modal-overlay">
// // //                     <div className="modal-content">
// // //                         <h3>Users using this Background</h3>
// // //                         <ul>
// // //                             {usersWithBackground.map((user, index) => (
// // //                                 <li key={index}>{user.name} ({user.phone_no})</li>
// // //                             ))}
// // //                         </ul>
// // //                         <button onClick={() => setModalOpen(false)}>Close</button>
// // //                     </div>
// // //                 </div>
// // //             )}
// // //         </>
// // //     );
// // // };

// // // export default GrowDraft;

// // // // import React, { useState, useEffect } from "react";


// // // // import { Link } from "react-router-dom";
// // // // import { collection, getDocs, query } from "firebase/firestore";
// // // // import db from "./Firebase";

// // // // const GrowDraft = () => {
// // // //     const [data, setData] = useState([]);
// // // //     const [uniqueBackgrounds, setUniqueBackgrounds] = useState({});
// // // //     const [selectedBackground, setSelectedBackground] = useState(null);
// // // //     const [usersWithBackground, setUsersWithBackground] = useState([]);

// // // //     useEffect(() => {
// // // //         const fetchData = async () => {
// // // //             const q = query(collection(db, "nv_users_saved_draft"));
// // // //             const querySnapshot = await getDocs(q);

// // // //             let fetchedData = [];
// // // //             let backgroundMap = {};

// // // //             querySnapshot.forEach((doc) => {
// // // //                 const { backgroundImage, name, phone_no } = doc.data();
// // // //                 if (backgroundImage) {
// // // //                     fetchedData.push({ backgroundImage, name, phone_no });
// // // //                     if (!backgroundMap[backgroundImage]) {
// // // //                         backgroundMap[backgroundImage] = [];
// // // //                     }
// // // //                     backgroundMap[backgroundImage].push({ name, phone_no });
// // // //                 }
// // // //             });

// // // //             setData(fetchedData);
// // // //             setUniqueBackgrounds(backgroundMap);
// // // //         };

// // // //         fetchData();
// // // //     }, []);

// // // //     const handleBackgroundClick = (background) => {
// // // //         setSelectedBackground(background);
// // // //         setUsersWithBackground(uniqueBackgrounds[background]);
// // // //     };

// // // //     return (

// // // //         <>
// // // //             <div className="p-2 d-flex justify-content-between">
// // // //                 <Link to="/">
// // // //                     <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
// // // //                 </Link>
// // // //             </div>

// // // //             <div className="p-3">
// // // //                 <div className="card-header pb-0 px-3">
// // // //                     <h6 className="mb-2">
// // // //                         Grow Background Usage -
// // // //                         {/* (Count: {displayedData.filter(({ data }) => data.phone_no && data.phone_no.length === 10).length}) */}
// // // //                     </h6>
// // // //                 </div>



// // // //                 {/* Membership Table */}
// // // //                 <div className="table-responsive fix-width scroll-inner">
// // // //                     <table className="table table-bordered table-hover">
// // // //                         <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
// // // //                             <tr>
// // // //                                 <th>Sr. No</th>
// // // //                                 <th>Background Image</th>
// // // //                                 <th>Users Count</th>
// // // //                             </tr>
// // // //                         </thead>
// // // //                         <tbody>
// // // //                             {Object.keys(uniqueBackgrounds).map((bg, index) => (
// // // //                                 <tr key={index}>
// // // //                                     <td>{index + 1}</td>
// // // //                                     <td><img src={bg} class="me-3" style={{ height: "4rem" }} /></td>
// // // //                                     <td>{uniqueBackgrounds[bg].length}</td>

// // // //                                 </tr>
// // // //                             ))}
// // // //                         </tbody>
// // // //                     </table>
// // // //                 </div>

// // // //                 {selectedBackground && (
// // // //                     <div className="mt-6 border border-gray-300 p-4 rounded-lg">
// // // //                         <h3 className="text-lg font-medium text-gray-700 mb-3">Users with Background: {selectedBackground}</h3>
// // // //                         <ul>
// // // //                             {usersWithBackground.map((user, index) => (
// // // //                                 <li key={index} className="border-b p-2">{user.name} ({user.phone_no})</li>
// // // //                             ))}
// // // //                         </ul>
// // // //                     </div>
// // // //                 )}
// // // //             </div>
// // // //         </>
// // // //     );
// // // // };

// // // // export default GrowDraft;